import React, { Component } from "react";
import { Button } from 'antd';
import {createTimeStr, hex2Rgba} from "../../../utils/common";

class App extends Component {
    state = {

    }

    componentDidMount(){

    }

    render() {
        const { themeColor, i18n, userInfo,showMorePaperinfo, interviewQuesVOs, selectedIndex, paperInfo } = this.props;

        return (
            <div className="video-info-wrap">
                <div className="video-paper-info">
                    {/*{*/}
                        {/*userInfo.aiVaild === 1 ?(userInfo.reportStatus == 2 ?*/}
                            {/*<div className="paper-download-wrap">*/}
                                {/*<button style={{color: themeColor, borderColor: themeColor, backgroundColor: hex2Rgba(themeColor, 0.05)}} onClick={this.downloadReport}>{i18n.report.download}</button>*/}
                            {/*</div>:*/}
                            {/*<div className="paper-download-wrap">*/}
                                {/*<button disabled style={{color: hex2Rgba(themeColor, 0.5), borderColor: themeColor, backgroundColor: hex2Rgba(themeColor, 0.05)}}>{i18n.report.generate}</button>*/}
                            {/*</div>):null*/}
                    {/*}*/}
                    <div className="video-paper-items">
                        <div className="video-paper-item">
                            <div className="video-paper-item-label">{i18n.result.recordStatus}</div>
                            {/* <div className="video-paper-item-content">{i18n.result.recordComplete}</div> */}
                            <div className="video-paper-item-content">{userInfo.statusDesc}</div>
                        </div>
                        <div className="video-paper-item">
                            <div className="video-paper-item-label">{i18n.result.submitStatus}</div>
                            <div className="video-paper-item-content">{userInfo.submitStatusDesc}</div>
                        </div>
                    </div>
                    {showMorePaperinfo ? <div className="video-paper-items">
                        <div className="video-paper-item">
                            <div className="video-paper-item-label">{i18n.result.finishTime}</div>
                            <div className="video-paper-item-content">{userInfo.finishTime}</div>
                        </div>
                        <div className="video-paper-item">
                            <div className="video-paper-item-label">{i18n.result.totalFileDuration}</div>
                            <div className="video-paper-item-content">{createTimeStr(userInfo.totalFileDuration)}</div>
                        </div>
                        <div className="video-paper-item">
                            <div className="video-paper-item-label">{i18n.result.startTime}</div>
                            <div className="video-paper-item-content">{userInfo.startTimeStr}</div>
                        </div>
                        <div className="video-paper-item">
                            <div className="video-paper-item-label">{i18n.result.endTime}</div>
                            <div className="video-paper-item-content">{userInfo.endTimeStr}</div>
                        </div>
                        <div className="video-paper-item">
                            <div className="video-paper-item-label">{i18n.result.paperName}</div>
                            <div className="video-paper-item-content">{i18n.lang == "en_us"? paperInfo.paperNameEn : paperInfo.paperName}</div>
                        </div>
                        <div className="video-paper-item">
                            <div className="video-paper-item-label">{i18n.result.questionNum}</div>
                            <div className="video-paper-item-content">{paperInfo.questionNum}</div>
                        </div>
                        <div className="video-paper-item">
                            <div className="video-paper-item-label">{i18n.result.videoResource}</div>
                            <div className="video-paper-item-content">{userInfo.videoResource}</div>
                        </div>
                        <div className="video-paper-item">
                            <div className="video-paper-item-label">{i18n.result.fileStatus}</div>
                            <div className="video-paper-item-content">{userInfo.fileStatus=="1"?i18n.result.fileNotExist:i18n.result.fileExist}</div>
                        </div>
                    </div> : null}
                    <div className="video-paper-items">
                        <div className="video-paper-item" onClick={this.props.showPaperinfo}>
                            <div className="video-paper-item-label">
                                <span>{i18n.result.moreBtnText}</span>
                                {showMorePaperinfo ?
                                    <i className="iconfont icon-drop-down icon-rotate"></i>
                                    :<i className="iconfont icon-drop-down"></i>}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="video-question-list">
                    <div className="video-question-title">{i18n.result.videoTitle}</div>
                    {interviewQuesVOs&&interviewQuesVOs.map((item, index) => {
                        return (
                            <div className={"video-question-item " + (selectedIndex === index?"selected":"")}
                                 onClick={() => this.props.handleClick(item.questionId, index)}
                                 key={index}>
                                <div className="video-question-item-content">{i18n.lang == "en_us" ? item.enName : item.cnName}</div>
                                <div className="video-question-item-tag">
                                    <i className="iconfont icon-ask" style={{color: selectedIndex === index ? themeColor : ""}}></i>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        );
    }
}

export default App;
